// extracted by mini-css-extract-plugin
export default {"fullWidth":"Lp-z","image":"Mp-z","lazyLoadPicture":"Np-z","lazyLoadSpinner":"Op-z","lazyLoadSpin":"Pp-z","lazyLoadImage":"Qp-z","hasStyledAspectRatio":"Rp-z"};